// extracted by mini-css-extract-plugin
export var active = "bC_bd";
export var categories = "bC_cJ";
export var category = "bC_cK";
export var icon = "bC_bw";
export var icons = "bC_bs";
export var image = "bC_d";
export var member = "bC_gN";
export var memberTitle = "bC_gP";
export var name = "bC_fV";
export var placeholder = "bC_bb";
export var section = "bC_b";
export var show = "bC_L";
export var subtitle = "bC_cV";
export var team = "bC_gM";